const widget =
  document.querySelector(
    '[data-goodlot-inbox]'
  );

const shopifyChat =
  document.querySelector(
    'shopify-chat'
  );


if (widget && shopifyChat) {

  const launcher =
    widget.querySelector(
      '[data-goodlot-inbox-launcher]'
    );

  const nudge =
    widget.querySelector(
      '[data-goodlot-inbox-nudge]'
    );

  const nudgeAction =
    widget.querySelector(
      '[data-goodlot-inbox-nudge-action]'
    );

  const nudgeClose =
    widget.querySelector(
      '[data-goodlot-inbox-nudge-close]'
    );

  const reducedMotion =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );


  let blinkTimer;
  let nudgeHideTimer;


  /* ========================================================
     CHAT STATE
     ======================================================== */

  function syncOpenState() {

    const isOpen =
      shopifyChat.hasAttribute(
        'open'
      );


    widget.hidden =
      isOpen;


    launcher?.setAttribute(
      'aria-expanded',
      String(isOpen)
    );


    if (isOpen) {
      widget.dataset.bubble =
        'off';
    }

  }


  /* ========================================================
     OPEN SHOPIFY INBOX
     ======================================================== */

  function openChat() {

    widget.dataset.bubble =
      'off';


    if (
      typeof shopifyChat.show ===
      'function'
    ) {

      shopifyChat.show();

    } else {

      shopifyChat.setAttribute(
        'open',
        ''
      );

    }


    syncOpenState();

  }


  /* ========================================================
     DISMISS NUDGE
     ======================================================== */

  function dismissNudge(event) {

    event?.stopPropagation();


    widget.dataset.bubble =
      'off';


    window.clearTimeout(
      nudgeHideTimer
    );


    try {

      sessionStorage.setItem(
        'goodlot-inbox-nudge-dismissed',
        'true'
      );

    } catch (_) {}

  }


  /* ========================================================
     RANDOM FACE BLINK
     ======================================================== */

  function scheduleBlink() {

  if (reducedMotion.matches) {
    return;
  }

  window.clearTimeout(
    blinkTimer
  );

  /*
    Keep normal GoodLot logo only briefly:
    random 4–6 seconds.
  */
  const logoDuration =
    4000 +
    Math.round(
      Math.random() * 2000
    );


  blinkTimer =
    window.setTimeout(
      () => {

        if (widget.hidden) {
          scheduleBlink();
          return;
        }


        /*
          Turn Logo into the face.
        */
        widget.classList.add(
          'is-blinking'
        );


        /*
          Keep the face visible much longer:
          8 seconds.
        */
        window.setTimeout(
          () => {

            widget.classList.remove(
              'is-blinking'
            );


            /*
              After returning to Logo,
              start the short 4–6 second
              logo period again.
            */
            scheduleBlink();

          },
          8000
        );

      },
      logoDuration
    );

}


  /* ========================================================
     INTRO MESSAGE
     ======================================================== */

  function showNudge() {

  let dismissed =
    false;


  try {

    dismissed =
      sessionStorage.getItem(
        'goodlot-inbox-nudge-dismissed'
      ) === 'true';

  } catch (_) {}


  if (
    dismissed ||
    shopifyChat.hasAttribute(
      'open'
    )
  ) {
    return;
  }


  /*
    Prevent random timer from interrupting
    the intro face state.
  */
  window.clearTimeout(
    blinkTimer
  );


  widget.dataset.bubble =
    'on';


  /*
    Show face.
  */
  widget.classList.add(
    'is-blinking'
  );


  /*
    Keep face for 8 seconds.
  */
  window.setTimeout(
    () => {

      widget.classList.remove(
        'is-blinking'
      );


      /*
        Now show Logo briefly,
        then return to face.
      */
      scheduleBlink();

    },
    8000
  );


  /*
    Questions? Ask us.
    stays for 11 seconds.
  */
  nudgeHideTimer =
    window.setTimeout(
      () => {

        widget.dataset.bubble =
          'off';

      },
      11000
    );

}


  /* ========================================================
     EVENTS
     ======================================================== */

  launcher?.addEventListener(
    'click',
    openChat
  );


  nudgeAction?.addEventListener(
    'click',
    openChat
  );


  nudgeClose?.addEventListener(
    'click',
    dismissNudge
  );


  /* ========================================================
     SHOPIFY CHAT OBSERVER
     ======================================================== */

  const observer =
    new MutationObserver(
      syncOpenState
    );


  observer.observe(
    shopifyChat,
    {
      attributes: true,

      attributeFilter: [
        'open',
        'mode'
      ]
    }
  );


  document.addEventListener(
    'shopify-chat:close',
    syncOpenState
  );


  document.addEventListener(
    'shopify-chat:open',
    syncOpenState
  );


  /* ========================================================
     INIT
     ======================================================== */

  customElements
    .whenDefined(
      'shopify-chat'
    )
    .then(
      () => {

        document.documentElement
          .classList.add(
            'goodlot-inbox-ready'
          );


        widget.hidden =
          false;


        syncOpenState();

        scheduleBlink();


        window.setTimeout(
          showNudge,
          9000
        );

      }
    );

}